"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/MOFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_154)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_154`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 -0.00012207H30V24.0002H-6V-0.00012207Z",
					fill: "#00745A"
				}),
				/* @__PURE__ */ n("path", {
					d: "M14.087 11.4993C13.7924 11.4993 13.5129 11.5581 13.2531 11.6515C13.3953 11.3344 13.4907 10.9816 13.4907 10.6049C13.4907 9.11419 12 7.99622 12 7.99622C12 7.99622 10.5093 9.11426 10.5093 10.6049C10.5093 10.9815 10.6046 11.3344 10.7468 11.6515C10.4872 11.5581 10.2075 11.4993 9.91287 11.4993C8.42217 11.4993 7.3042 12.99 7.3042 12.99C7.3042 12.99 8.42224 14.4807 9.91287 14.4807C10.7868 14.4807 11.5322 13.9684 11.9999 13.5445C12.4675 13.9685 13.2128 14.4807 14.0869 14.4807C15.5776 14.4807 16.6956 12.99 16.6956 12.99C16.6956 12.99 15.5777 11.4993 14.087 11.4993Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 4.69531L12.3079 5.64285H13.3043L12.4983 6.22869L12.806 7.17622L12 6.59052L11.194 7.17622L11.5017 6.22869L10.6956 5.64285H11.692L12 4.69531ZM8.21096 6.35272L8.80335 6.88604L9.49368 6.48758L9.16954 7.21567L9.76178 7.7492L8.96907 7.66588L8.64486 8.39397L8.47907 7.61434L7.68629 7.53102L8.37662 7.13242L8.21096 6.35272ZM5.43713 9.12648L6.2169 9.29228L6.61543 8.60195L6.69882 9.39465L7.47852 9.56045L6.75029 9.88459L6.83368 10.6773L6.30022 10.0851L5.57199 10.4092L5.97059 9.71887L5.43713 9.12648ZM15.789 6.35272L15.1967 6.88604L14.5063 6.48758L14.8305 7.21567L14.2382 7.7492L15.0309 7.66588L15.3551 8.39397L15.5209 7.61434L16.3137 7.53102L15.6234 7.13242L15.789 6.35272ZM18.5628 9.12648L17.7831 9.29228L17.3845 8.60195L17.3011 9.39465L16.5215 9.56045L17.2497 9.88459L17.1664 10.6773L17.6998 10.0851L18.428 10.4092L18.0294 9.71887L18.5628 9.12648Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12 18.6546C13.1841 18.6546 14.2756 18.2595 15.1512 17.5948H8.84905C9.72451 18.2595 10.816 18.6546 12 18.6546ZM7.21716 15.5242C7.38207 15.9007 7.59094 16.2565 7.83943 16.584H16.1606C16.4091 16.2565 16.6179 15.9007 16.7828 15.5242H7.21716Z",
					fill: "white"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_154`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as MOFlag };
